import React from 'react';
import { Switch, Route } from 'react-router-dom'
import { PeriodReport } from './PeriodReport'
import { SyncReport } from './SyncReport';

const view = ({ items }) => {
    return (
        <div>
            <nav className="lg:pr-6 flex menu-2 shadow bg-white font-semibold text-xs rounded-sm text-vivid-900">
                <ul className="wtf-menu flex w-full">
                    {items}
                </ul>
            </nav>

            <div className="route">
                <Switch>
                    <Route path="/reports" exact component={null} />
                    <Route path="/reports/cars/report" component={PeriodReport} />
                    <Route path="/reports/cars/access" component={SyncReport} />
                </Switch>
            </div>
        </div>
    );
};

export default view;